import React from 'react';
import {Table} from 'react-bootstrap'
import StartListRow from './StartListRow'

export default (props) => {
    return (
        <Table bordered hover>
        <thead className="thead-dark"> 
            <tr>
                <th>#</th>
                <th>Navn</th>
                <th className="d-none d-sm-table-cell">Etternavn</th>
                <th className="d-none d-sm-table-cell">Klubb</th>
                <th>Start</th>
            </tr>
        </thead>
        <tbody>
        {props.competitors && props.competitors.sort( (a, b) => a.startNo - b.startNo ).map( competitor => 
            <StartListRow selectCompetitor={props.selectCompetitor} event={props.event} key={competitor.id} competitor={competitor} />
            )
        }
        </tbody>
        </Table>

    );
};
